import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import StyledTextField from '../ui/StyledTextField';
import useStyles from './styles';

const InputRow = forwardRef(({ name, label, value, onChange, refInput, nextRef, price }, _) => {
  const classes = useStyles();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && nextRef && nextRef.current) {
      e.preventDefault();
      nextRef.current.focus();
    }
  };

  return (
    <div className={classes.rowContainer}>
      <div className={classes.inputSection}>
        <StyledTextField
          fullWidth
          label={label}
          type="number"
          name={name}
          value={value}
          onChange={onChange}
          variant="outlined"
          size="small"
          inputRef={refInput}
          onKeyDown={handleKeyDown}
        />
      </div>
      <Typography variant="h6" className={classes.priceDisplay}>
        {price.toFixed(0)} €
      </Typography>
    </div>
  );
});

InputRow.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  refInput: PropTypes.object.isRequired,
  nextRef: PropTypes.object,
  price: PropTypes.number.isRequired,
};

export default InputRow;
